import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import Categories from '@/views/categories/List.vue';

export const categoryRoute: RouteConfig = {
  path: 'categories',
  name: 'categories',
  component: Categories,
  beforeEnter: (to, from, next) => {
    store.commit('breadcrumbs/set', [{ text: 'Kategorie', disabled: true }]);
    store
      .dispatch('categories/list', { ...baseFilters(to) })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać kategorii.' }));
  },
  meta: { toolbarTitle: 'Lista kategorii' }
};
